import React from "react";

export default function ArrowDownIcon() {
    return (
        <svg fill="#973794" height="8px" width="8px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink"
             viewBox="0 0 386.257 386.257" xmlSpace="preserve">
        <polygon points="0,96.879 193.129,289.379 386.257,96.879 "/>
        </svg>
    );
}
